/**
 * Cards!!
 *  @descricao - Descrição na Base do Card
 *  @tema - Estilo do card
 *  @tooltip - Texto tooltip
 *  @placement - posicionamento do tooltip: 'top', 'bottom', 'left', 'right'
 *  @valor - Valor principal do Card
 *  @sufix - Sufixo ao valor do card - Informação complementar/contextual
 *  @valorProgressBar - Valor no progressbar
*/

<template>
    <div class="flex">
        <sp-360-panel class="info-widget" :stripe="stripe" :class="level" :image="image" v-bind:enableTooltipOverflowX="false" :color="tema" :footerText="footerText" :footerComplementar="footerComplementar">
            <div class="info-widget-inner has-chart">
                <!-- Dados internos do Card -->
                <div class="stats" v-if="checarValor(valor)" viewPort >
                    <div class="stats-number">
                        <va-icon v-if="icon" :name="computedIcon" :color='computedIconColor' slot="prepend" class="boldness" v-bind:title="computedIconHint"/>
                        <span class="boldness">{{valorComputado}} {{sufix}}</span>
                        <div class="chart-container" v-if="valorProgressBar">
                          <va-progress-circle :key="progressKey" :value="valorProgressBar">
                            <span class="progress-bar-text"> {{ valorProgressBar }}% </span>
                          </va-progress-circle>
                        </div>
                    </div>
                    <div class="stats-title">
                        <span :class="classeDescricao">{{descricao}} </span>
                      <vuestic-tooltip v-if="tooltipComputado" :options="tooltipComputado">
                        <span class="fa fa-question-circle-o fa-lg toolTipHelp"></span>
                      </vuestic-tooltip>
                    </div>
                </div>
                <!-- Se os Status estiverem indefinidos no momento da renderização um spinner aparecerá -->
                <div class="stats" v-else>
                  <div>
                      <semipolar-spinner class="boldness empty-card" :animation-duration="2000" :size="50" :color="$themes.success" align="middle"/>
                  </div>
                </div>
            </div>
        </sp-360-panel>
    </div>
</template>

<script>
import MethGlob from '@/utils/MetodosGlobais'
import VuesticTooltip from '@/vuestic-theme/vuestic-components/vuestic-tooltip/VuesticTooltip'
import { SemipolarSpinner } from 'epic-spinners'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'sp-card2',

  components: {
    VuesticTooltip,
    SemipolarSpinner,
    Sp360Panel,
  },
  data () {
    return {
      progressKey: 1,
      backgroundTheme: '',
      theme: '',
      tooltipCustom: 'vuestic-tooltip ',
      level: '',
    }
  },
  computed: {
    shape () {
      return this.classes + ' ' + this.gridSize()
    },
    gridSize () { return `md${this.mdGrid} lg${this.lgGrid} xl${this.lgGrid} xs12` },
    valorComputado () { return !isNaN(this.valor) ? MethGlob.thousandSeparator(this.valor) : this.valor },
    tooltipComputado () {
      let classes = this.tooltipCustom.concat(this.tooltipClasses)
      return this.tooltip ? { content: this.tooltip, placement: this.placement, classes: classes } : null
    },
    computedIcon () { return this.icon },
    computedIconColor () {return this.iconColor},
    computedIconHint () {return this.iconHint},
    classeDescricao () { return this.classDesc || '' },
  },

  props: {
    placement: {
      type: String,
      default: 'bottom',
    },
    descricao: {
      type: String,
      default: '',
    },
    classDesc: {
      type: String,
    },
    tema: {
      type: String,
    },
    valor: {
      default: 0,
    },
    sufix: {
      default: '',
      type: String,
    },
    tooltip: {
      type: String,
      default: null,
    },
    tooltipClasses: {
      type: String,
      default: '',
    },
    valorProgressBar: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '',
    },
    iconHint: {
      type: String,
      default: '',
    },
    image: {
      type: String,
    },
    stripe: {
      type: String,
      default: 'success',
    },
    footerText: {
      type: String,
    },
    footerComplementar: {
      type: String,
    },
    classes: {
      type: String,
      default: 'flex',
    },
  },

  methods: {
    reloadCard () {
      this.progressKey += 1
    },
    _defineTema (tema) {
      if (tema.toLowerCase() == 'danger') {
        this.theme = 'White'
        this.backgroundTheme = 'Danger'
        this.level = 'brand-danger'
        this.tooltipCustom = 'toolTipHelp-white'
        
      } else if (tema.toLowerCase() == 'info') {
        this.theme = 'White'
        this.backgroundTheme = 'Info'
        this.level = 'brand-info'
        this.tooltipCustom = 'toolTipHelp-white'
      } else {
        this.theme = 'Primary'
        this.backgroundTheme = 'White'
        this.level = ''
      }
    },
    checarValor (valor) {
      if (typeof valor === 'undefined' || valor === null) return false
      return true
    },
  },
}
</script>

<style lang="scss">
  .toolTipHelp-white{
     color: white;
     cursor: help;
  }

  .empty-card{
    text-align: center;
  }

  .boldness{
      font-size: clamp(1rem, 2.5vw, 2.5rem);  //min(8rem, 1.2rem);
      font-weight: 900;
      // @include media-breakpoint-down(sm) {
      //   font-size: 7.5vw;
      // }
  }

  .info-widget{
    padding-top: $card-padding;
    min-width: 10vw;
    max-width: 1fr;
  }

  .info-widget-inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }

  .disclaimer{
    display: block;
    text-align: right;
    font-style: italic;
    color:gray;
  }

  .card-tooltip-header{
    height: 10%;
  }

  .stats{
    width: 100%;
  }

  .stats-title{
    font-size: clamp(0.8rem, 1vw, 1rem);
  }

  .stats-number{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
    //width: 100vw;
  }

 .va-card{
  &__footer {
    &-inner {
      display: flex;
      padding: 0.5rem $card-padding;
      min-height: 3.5rem;
      align-items: center;
    }

    &-title {
      font-weight: 100;
      font-size: 0.9rem;
      letter-spacing: $card-title-letter-spacing;
      text-transform: none;
      color: $cinza-claro !important;
      padding-left: 0.8rem;
      padding-bottom: 0.4rem;
    }

    &-actions {
      margin-left: auto;
      flex: 0 0 auto;
    }
 }
 }
</style>

<style lang="scss" >
  .va-progress-circle{
    width: 3.125rem;
    height: 3.125rem;

    &__info {
      font-size: 0.75rem;
      font-weight: bold
    }
  }

  .progress-bar-text{
    font-size: 0.85rem;
    font-weight: bold
  }

</style>
<style lang="scss">
  .topCardGrid{
    display: grid;
    grid-template-columns: repeat( auto-fit, minmax(150px, 1fr) );
  }
</style>
